var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { SportDataGatewayQueryInfo } from "sb-bff-integration";
import { observable } from "mobx";
import { queryBuilder, marketsFilter } from "../queryHelpers";
export const initialSportsDataFeed = {
    data: {
        add: {
            events: [],
            markets: []
        },
        change: {
            events: [],
            markets: []
        },
        remove: {
            events: [],
            markets: []
        }
    },
    warnings: []
};
export const failureSportsDataFeed = {
    data: {
        add: {
            events: [],
            markets: []
        },
        change: {
            events: [],
            markets: []
        },
        remove: {
            events: [],
            markets: []
        }
    },
    warnings: []
};
/*
    The class has 'istanbul ignore' flag , because of testing typescript interface with Jest.
    It`s known issue : (https://github.com/kulshekhar/ts-jest/issues/378)
    The class is fully tested, but property "sportsDataChangeFeed" implement interface "ChangeFeedUpdate" which is not
    testable with Jest - there is no types like in typescript
 */
/* istanbul ignore next */
export class SportDataGateWayRetriever {
    constructor(sdApiGateway) {
        this.sdApiGateway = sdApiGateway;
        this.sportsDataChangeFeed = initialSportsDataFeed;
        this.healthCheck = true;
        this.shouldRemoveEvents = false;
        this.eventIds = {
            All: [],
            Outrights: []
        };
        this.messageHandler = this.messageHandler.bind(this);
    }
    activate(eventIds) {
        if (eventIds.All.length === 0) {
            return;
        }
        this.eventIds = eventIds;
        const eventsQuery = queryBuilder(this.eventIds.All);
        const queryInfo = new SportDataGatewayQueryInfo(eventsQuery, this.messageHandler);
        queryInfo.initialData = "true";
        queryInfo.includeMarkets = marketsFilter(this.eventIds.Outrights);
        queryInfo.onErrorHandler = this.setFailureSportsDataChangeFeed.bind(this);
        this.sdApiGateway.subscribeForEvents(queryInfo);
    }
    setFailureSportsDataChangeFeed() {
        this.shouldRemoveEvents = true;
    }
    deactivate() { }
    messageHandler(data) {
        this.shouldRemoveEvents = false;
        let response = this.filterResponse(data);
        if (this.shouldProcessUpdate(response)) {
            // observed by Data Facade for changes
            this.sportsDataChangeFeed = response;
        }
    }
    shouldProcessUpdate(res) {
        return !(res.data.add.events.length === 0
            && res.data.add.markets.length === 0
            && res.data.change.events.length === 0
            && res.data.change.markets.length === 0
            && res.data.remove.events.length === 0
            && res.data.remove.markets.length === 0);
    }
    filterResponse(data) {
        let filteredResponse = {
            data: {
                add: {
                    events: this.filterEventIdsByEvent(data.data.add.events),
                    markets: this.filterEntityByEventId(data.data.add.markets, (market, eventId) => eventId === parseInt(market.eventId, 10)),
                },
                change: {
                    events: this.filterEntityByEventId(data.data.change.events, (event, eventId) => eventId === parseInt(event.id, 10)),
                    markets: this.filterEntityByEventId(data.data.change.markets, (market, eventId) => eventId === parseInt(market.eventId, 10)),
                },
                remove: {
                    events: this.filterEntityByEventId(data.data.remove.events, (event, eventId) => eventId === parseInt(event, 10)),
                    markets: data.data.remove.markets
                }
            },
            warnings: []
        };
        return filteredResponse;
    }
    filterEntityByEventId(entity, filterCallback) {
        let ref = this;
        return entity.filter(e => ref.eventIds.All.some(eventId => filterCallback.call(ref, e, eventId)));
    }
    filterEventIdsByEvent(events) {
        return events.filter(event => this.eventIds.All.find(id => parseInt(event.id, 10) === id));
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], SportDataGateWayRetriever.prototype, "sportsDataChangeFeed", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], SportDataGateWayRetriever.prototype, "shouldRemoveEvents", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], SportDataGateWayRetriever.prototype, "healthCheck", void 0);
//# sourceMappingURL=SportDataGateWayRetriever.js.map